import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.flags = parseInt(payload.flags, 10)
  payload.free_balance = parseFloat(payload.free_balance)
  payload.group_id = parseInt(payload.group_id, 10)
  payload.id = parseInt(payload.id, 10)
  payload.interval_duration = parseInt(payload.interval_duration, 10)
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.last_payment_date = parseInt(payload.last_payment_date, 10)
  payload.max_duration = parseInt(payload.max_duration, 10)
  payload.max_value = parseFloat(payload.max_value)
  payload.min_balance = parseFloat(payload.min_balance)
  payload.priority = parseInt(payload.priority, 10)
  payload.service_id = parseInt(payload.service_id, 10)
  payload.use_free_balance = parseInt(payload.use_free_balance, 10)
  payload.use_min_balance = parseInt(payload.use_min_balance, 10)
}

var state = {
  promisedPaymentsSettings: []
}

var getters = {
  PROMISED_PAYMENTS_SETTINGS: (state) => {
    return state.promisedPaymentsSettings
  }
}

var mutations = {
  SET_PROMISED_PAYMENTS_SETTINGS: (state, payload) => {
    state.promisedPaymentsSettings = payload
  }
}

var actions = {
  GET_PROMISED_PAYMENTS_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/promised_payments')
    if (result.status === 200) {
      context.commit('SET_PROMISED_PAYMENTS_SETTINGS', result.data)
    }
  },
  CREATE_PROMISED_PAYMENTS_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/promised_payments', payload)
  },
  UPDATE_PROMISED_PAYMENTS_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/promised_payments', payload)
  },
  DELETE_PROMISED_PAYMENTS_SETTINGS: (context, payload) => {
    return axiosInstance.delete('/settings/promised_payments?promised_payment_settings_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/promisedPayment.js